// 封面：清單與詳情共用。沒有封面或載入失敗時，以名稱縮寫與穩定色相的漸層代替，避免破圖。
import { useState } from 'react';
import { t } from '../i18n/zh-TW.ts';
import { hueOf, imageUrl } from '../lib/format.ts';

const SIZES = {
  small: { width: 72, height: 96, img: 'cover_small', img2x: 'cover_big', className: 'cover' },
  large: { width: 132, height: 176, img: 'cover_big', img2x: 'cover_big', className: 'detail-cover' },
  /** 海報牆：寬度隨欄寬（CSS 3:4），寬高屬性讓瀏覽器在圖片載入前就保留空間 */
  poster: { width: 264, height: 352, img: 'cover_big', img2x: 'cover_big', className: 'poster-img' },
} as const;

export function initials(name: string): string {
  return name
    .replace(/[^\p{L}\p{N} ]/gu, '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => [...w][0]?.toUpperCase())
    .join('');
}

interface CoverProps {
  id: string;
  name: string;
  cover?: string;
  size?: keyof typeof SIZES;
  lazy?: boolean;
}

export function Cover({ id, name, cover, size = 'small', lazy = true }: CoverProps) {
  const [failed, setFailed] = useState(false);
  const s = SIZES[size];
  const src = imageUrl(cover, s.img);
  if (!src || failed) {
    const hue = hueOf(id);
    return (
      <div
        className={`${s.className} cover-fallback`}
        role="img"
        aria-label={t.card.coverAlt(name)}
        style={{ background: `linear-gradient(135deg, hsl(${hue} 55% 42%), hsl(${(hue + 40) % 360} 60% 28%))` }}
      >
        <span aria-hidden="true">{initials(name)}</span>
      </div>
    );
  }
  return (
    <img
      className={s.className}
      src={src}
      srcSet={`${src} 1x, ${imageUrl(cover, s.img2x)} 2x`}
      alt={t.card.coverAlt(name)}
      width={s.width}
      height={s.height}
      loading={lazy ? 'lazy' : 'eager'}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
